module.exports = __webpack_public_path__ + "img/enging_room_pic06.b820f843.png";